import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import { isUserAuthenticated } from '../helpers/authUtils';
// All layouts/containers
import AuthLayout from '../layouts/Auth';
import HorizontalLayout from '../layouts/Horizontal';
import { allFlattenRoutes as routes } from './index';


class Routes extends Component {
  getLayout = () => {
    return !isUserAuthenticated() || !this.props.user ? AuthLayout : HorizontalLayout;
  };

  render() {
    const Layout = this.getLayout();
    return (
        <Layout {...this.props}>
          <Switch>
            {routes.map((route, index) => {
              return (
                !route.children && (
                  <route.route
                    key={index}
                    path={route.path}
                    roles={route.roles}
                    exact={route.exact}
                    component={route.component}>
                  </route.route>
                )
              );
            })}
          </Switch>
        </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.Auth.user,
  };
};

export default connect(mapStateToProps)(Routes);